import { action } from 'satcheljs';
import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { PlaceType } from 'owa-location-service';

export let fetchLocationDetails = action('fetchLocationDetails', (locationId: string) => ({
    locationId,
}));

export let initializePlace = action(
    'initializePlace',
    (
        name: string,
        postalAddress: PersonaPostalAddress,
        locationId: string,
        locationType: PlaceType,
        phoneNumber: string
    ) => ({
        name,
        postalAddress,
        locationId,
        locationType,
        phoneNumber,
    })
);

export let initializeLocationCardIfNeeded = action(
    'initializeLocationCardIfNeeded',
    (
        name: string,
        postalAddress: PersonaPostalAddress,
        locationId: string,
        locationType: PlaceType,
        colorScheme: ColorScheme,
        phoneNumber?: string
    ) => ({
        name,
        postalAddress,
        locationId,
        locationType,
        colorScheme,
        phoneNumber,
    })
);
